import { ref } from 'vue';
import { defineStore } from 'pinia';
import { initSettings } from '@/api/settings';
import { handleKnownSettingsApiErrors } from '@/stores/settings/errorHandling';
import { useAppSnackbar } from '@/stores/app/snackbar';

export const useSettingsConfig = defineStore('settingsConfig', () => {
  const config = ref({
    projectName: '',
    atsName: '',
    atsId: 0,
    integrationTypeKey: 0,
    projectImageUrl: '',
    showIntegrationsPage: false,
    canTeam: false,
    canTeamAdmin: false,
    canIntegrations: false,
    canEditTemplates: false,
    canSeeTemplates: false,
    canBilling: false,
    canGreenhouseRoles: false,
    canCustomFields: false,
  });

  const setConfig = (newConfig) => {
    config.value = newConfig;
  };

  const load = async () => {
    try {
      const newConfig = await initSettings();

      setConfig(newConfig);
    } catch (error) {
      const knownError = handleKnownSettingsApiErrors({ context: 'Initialize settings', error });

      if (knownError) return;

      useAppSnackbar().addErrorSnackbar({
        text: `Initialize settings - ${error.message}`,
      });

      throw error;
    }
  };

  return { config, setConfig, load };
});
